<script lang="ts">
import { StreamLanguage } from "@codemirror/stream-parser";
import { yaml } from "@codemirror/legacy-modes/mode/yaml";
import { EditorState, EditorView, basicSetup } from "@codemirror/basic-setup";
import { onMount } from "svelte";
import TextButton from "../common/TextButton.svelte";
import { LoadSource } from "@src/jit/JIT";
import EditorStore from "@src/model/Editor.Store";


// because One Dark is probably the worst dark theme one can ever have...


let editorParentElement: HTMLDivElement;
let editor: EditorView;


function handleReload() {
    LoadSource(editor.state.doc.toJSON().join('\n'));
}
let updateListenerExtension = EditorView.updateListener.of(handleReload);
onMount(() => {
    editor = new EditorView({
        state: EditorState.create({
            extensions: [
                basicSetup,
                StreamLanguage.define(yaml),
                updateListenerExtension,
            ],
            doc: [
`main:`,
`  video_src: "assets/vid.mp4"`,
`  interact:`,
`    - around: 0:01`,
`      info:`,
`        text: |`,
`          what is the frog called?`,
``,
`    - around: 0:02`,
`      prompt:`,
`        target: blah_1`,
`        text: |`,
`          info. what is the frog called?`,
`    - around: 0:05`,
`      choose:`,
`        text: |`,
`          choose text.`,
`        choices:`,
`          - id: A`,
`            text: choice A (goto 0:03)`,
`            target: 0:03`,
`          - id: B`,
`            text: choice B (goto 0:04)`,
`            target: 0:04`,
`          - id: C`,
`            text: choice C (goto 0:06)`,
`            target: 0:06`,
`          - id: D`,
`            text: choice D (goto 0:08)`,
`            target: 0:08`,
`          `,
            ].join('\n'),
        }),
        parent: editorParentElement,
    });
    (editorParentElement.querySelector('.cm-editor') as any)?.style.setProperty('height', '100%')
    EditorStore.getValue().currentCodeMirrorEditor = editor;
});

</script>


<div id="ivdemo-source-editor">
    <div id="ivdemo-source-editor-action-bar">
        <TextButton label="RELOAD" onClick={handleReload} />
    </div>
    <div id="ivdemo-source-editor-container" bind:this={editorParentElement}>

    </div>
</div>

<style>
    #ivdemo-source-editor-action-bar {
        position: fixed;
        top: 0;
        left: 0;
        width: 40%;
        height: 1rem;
        background-color: black;
        color: white;
    }
    #ivdemo-source-editor-container {
        position: fixed;
        top: 1rem;
        left: 0;
        bottom: 300px;
        width: 40%;
        background-color: white;
    }
</style>
